import ClusterSummaryCard from './clusterSummaryCard.container';

export default ClusterSummaryCard;